import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

interface CallIntelDemoState {
  isDemoAccount: boolean;
  isDemoModal: boolean;

  setIsDemoAccount: (isDemoAccount: boolean) => void;
  setIsDemoModal: (isDemoModal: boolean) => void;
}

const useCallIntelDemoStore = createStoreWithSubscribe<CallIntelDemoState>(
  (set) => ({
    isDemoAccount: false,
    isDemoModal: false,

    setIsDemoAccount: (isDemoAccount) => {
      set({ isDemoAccount });
    },
    setIsDemoModal: (isDemoModal) => {
      set({ isDemoModal });
    },
  }),
  {
    name: 'CallIntelDemoStore',
    trace: true,
  }
);

export const useCallIntelDemoShallowStore = createShallowStore<CallIntelDemoState>(useCallIntelDemoStore);
